import React from 'react';
import { SET_ALERT, CLEAR_ALERT, SET_AUTH } from '../types';

export default (state, action) => {
    switch (action.type) {
        case SET_AUTH:
            console.log('SETTING AUTH payload', action)
            return {
                ...state,
                auth: {
                    ...action.payload
                }
            }
        case SET_ALERT:
            console.log('alert payload', action)
            return {
                ...state,
                alert: {
                    ...action.payload
                }
            }
        case CLEAR_ALERT:
            return {
                ...state,
                alert: null
            }
        default:
            return state;
    }
};